import { ErrorToast, getConfig, handleApiError } from "../Util";
import Axios from "../WebClient";

export const GetMonazamLedgerTransactions = (
  setTransaction,
  setUsers,
  setAmount,
  currency,
  bankAccountId = undefined,
  setLoading,
  setError,
  setBankAccounts = null,
  isMonazam = true
) => {
  // Validate all required functions
  if (typeof setLoading !== 'function') {
    console.error('setLoading is not a function', { 
      setLoading, 
      bankAccountId,
      currency
    });
    return;
  }
  if (typeof setError !== 'function') {
    console.error('setError is not a function');
    return;
  }
  
  setLoading(true);
  let url = "/ledger/transactions?type=monazam";
  if (currency) {
    url += `&currency=${currency}`;
  }
  if (bankAccountId && bankAccountId !== "" && bankAccountId !== null && currency === "PKR") {
    url += `&monazamBankAccountId=${bankAccountId}`;
  }
  Axios.get(url, getConfig())
    .then((res) => {
      let transactions = res.data.data.transactions;
      let users = res.data.data.users;
      
      if (setBankAccounts && res.data.data.pkrBankAccounts) {
        setBankAccounts(res.data.data.pkrBankAccounts);
      }
      
      let currentHGOId = null;
      if (!isMonazam) {
        const currentUserId = localStorage.getItem("id");
        if (currentUserId && users && users.length > 0) {
          const currentUser = users.find(user => user.userId === currentUserId);
          if (currentUser && currentUser.id) {
            currentHGOId = currentUser.id;
          }
        }
      }
      
      if (currency === "PKR") {
        let bankBalance = 0;
        if (isMonazam) {
          if (bankAccountId && res.data.data.pkrBankAccounts) {
            const selectedBank = res.data.data.pkrBankAccounts.find(
              bank => bank.id === bankAccountId
            );
            if (selectedBank) {
              bankBalance = selectedBank.balance || 0;
            }
          } else {
            bankBalance = res.data.data.pkrMonazamLedgerBalance || 0;
          }
        } else {
          // For HGO users, use the same logic as Monazam - use bank account balance if selected
          if (bankAccountId && res.data.data.pkrBankAccounts) {
            const selectedBank = res.data.data.pkrBankAccounts.find(
              bank => bank.id === bankAccountId
            );
            if (selectedBank) {
              bankBalance = selectedBank.balance || 0;
            }
          } else {
            // If no bank selected, use the overall ledger balance
            bankBalance = res.data.data.pkrMonazamLedgerBalance || 0;
          }
        }
        setAmount(bankBalance);
        
        // For combined table: show all transactions (same for both Monazam and HGO portals)
        // Only filter by currency and bankAccountId
        let combinedTableTransactions = transactions.filter((transaction) => {
          if (transaction.currency !== "PKR") {
            return false;
          }
          if (bankAccountId) {
            return transaction.monazamBankAccountId === bankAccountId || 
                   transaction.bankAccountId === bankAccountId;
          }
          return true;
        });
        setTransaction(combinedTableTransactions);
        
        let filteredUsers = users;
        if (!isMonazam) {
          if (currentHGOId) {
            filteredUsers = users.filter(user => user.id === currentHGOId);
          } else {
            filteredUsers = [];
          }
        }
        
        setUsers(
          filteredUsers.map((user) => {
            let userTransactions = user.transactions.filter(
              (transaction) => {
                const currencyMatch = transaction.currency === "PKR";
                if (!currencyMatch) {
                  return false;
                }
                // For HGO: transactions in user.transactions are already associated with this user
                // Only filter by currency and bankAccountId if provided
                if (!isMonazam) {
                  // All transactions in user.transactions belong to this HGO, so include them
                  // Only filter by bankAccountId if provided
                  if (bankAccountId) {
                    return transaction.bankAccountId === bankAccountId ||
                      transaction.monazamBankAccountId === bankAccountId;
                  }
                  return true;
                }
                // For Monazam: filter by bankAccountId if provided
                // For Unclaimed user: don't filter by bankAccountId (show all transactions)
                if (user.name === "Unclaimed") {
                  return true; // Show all PKR transactions for Unclaimed
                }
                if (bankAccountId) {
                  return transaction.bankAccountId === bankAccountId ||
                    transaction.monazamBankAccountId === bankAccountId;
                }
                return true;
              }
            );
            user.transactions = userTransactions;
            return user;
          })
        );
      } else if (currency === "USD") {
        // For both Monazam and HGO, use the same overall ledger balance
        setAmount(res.data.data.usdMonazamLedgerBalance || 0);
        // For combined table: show all transactions (same for both Monazam and HGO portals)
        // Only filter by currency
        let combinedTableTransactions = transactions.filter((transaction) => {
          return transaction.currency === "USD";
        });
        setTransaction(combinedTableTransactions);
        
        let filteredUsers = users;
        if (!isMonazam) {
          if (currentHGOId) {
            filteredUsers = users.filter(user => user.id === currentHGOId);
          } else {
            filteredUsers = [];
          }
        }
        
        setUsers(
          filteredUsers.map((user) => {
            let transactions = user.transactions.filter(
              (transaction) => {
                if (transaction.currency !== "USD") {
                  return false;
                }
                // For HGO: transactions in user.transactions are already associated with this user
                // Only filter by currency
                if (!isMonazam) {
                  // All transactions in user.transactions belong to this HGO, so include them
                  return true;
                }
                // For Monazam: For Unclaimed user, show all USD transactions
                // (no additional filtering needed for USD as there's no bankAccountId filter)
                return true;
              }
            );
            user.transactions = transactions;
            return user;
          })
        );
      }
      setError("");
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data.");
      ErrorToast(err?.response?.data?.message);
    });
};

export const GetOpapLedgerTransactions = (
  setTransaction,
  setUsers,
  setAmount,
  setLoading,
  setError,
  isMonazam = true
) => {
  setLoading(true);
  Axios.get("/ledger/transactions?type=opap", getConfig())
    .then((res) => {
      let transactions = res.data.data.transactions;
      let users = res.data.data.users;
      
      let currentHGOId = null;
      if (!isMonazam) {
        const currentUserId = localStorage.getItem("id");
        if (currentUserId && users && users.length > 0) {
          const currentUser = users.find(user => user.userId === currentUserId);
          if (currentUser && currentUser.id) {
            currentHGOId = currentUser.id;
          }
        }
      }
      
      // For both Monazam and HGO, use the same overall ledger balance
      setAmount(res.data.data.sarOpapLedgerBalance || 0);
      
      // For combined table: show all transactions (same for both Monazam and HGO portals)
      // Only filter by ledger type (opap)
      let combinedTableTransactions = transactions.filter((transaction) => {
        const typeMatch = transaction.type === "opap" || transaction.ledgerType === "opap";
        return typeMatch;
      });
      setTransaction(combinedTableTransactions);
      
      let filteredUsers = users;
      if (!isMonazam) {
        // For HGO portal: Only show the logged-in HGO (exclude "Unclaimed")
        if (currentHGOId) {
          filteredUsers = users.filter(user => user.id === currentHGOId);
        } else {
          filteredUsers = [];
        }
      } else {
        // For Monazam portal: Exclude "Unclaimed" user from OPAP ledger
        // Include other users that have OPAP-related data
        filteredUsers = users.filter(user => {
          // Exclude "Unclaimed" user
          if (user.name === "Unclaimed") {
            return false;
          }
          // Include other users that have OPAP-related data
          return user.sarOpapLedgerAmount !== null && user.sarOpapLedgerAmount !== undefined;
        });
      }
      
      setUsers(
        filteredUsers.map((user) => {
          let userTransactions = user.transactions.filter(
            (transaction) => {
              const typeMatch = transaction.type === "opap" || transaction.ledgerType === "opap";
              if (!typeMatch) {
                return false;
              }
              // For HGO: transactions in user.transactions are already associated with this user
              // Only filter by ledger type
              if (!isMonazam) {
                // All transactions in user.transactions belong to this HGO, so include them
                return true;
              }
              return true;
            }
          );
          user.transactions = userTransactions;
          return user;
        })
      );
      setError("");
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
      setError("Error fetching data");
      ErrorToast(err?.response?.data?.message);
    });
};

export const GetEHajjLedgerTransactions = (
  setTransaction,
  setUsers,
  setAmount,
  setLoading,
  setError,
  isMonazam = true
) => {
  setLoading(true);
  Axios.get("/ledger/transactions?type=ehajj", getConfig())
    .then((res) => {
      let transactions = res.data.data.transactions;
      let users = res.data.data.users;
      
      let currentHGOId = null;
      if (!isMonazam) {
        const currentUserId = localStorage.getItem("id");
        if (currentUserId && users && users.length > 0) {
          const currentUser = users.find(user => user.userId === currentUserId);
          if (currentUser && currentUser.id) {
            currentHGOId = currentUser.id;
          }
        }
      }
      
      // For both Monazam and HGO, use the same overall ledger balance
      setAmount(res.data.data.sarEhajjLedgerBalance || 0);
      
      // For combined table: show all transactions (same for both Monazam and HGO portals)
      // Only filter by ledger type (ehajj)
      let combinedTableTransactions = transactions.filter((transaction) => {
        const typeMatch = transaction.type === "ehajj" || transaction.ledgerType === "ehajj";
        return typeMatch;
      });
      setTransaction(combinedTableTransactions);
      
      let filteredUsers = users;
      if (!isMonazam) {
        // For HGO portal: Only show the logged-in HGO (exclude "Unclaimed")
        if (currentHGOId) {
          filteredUsers = users.filter(user => user.id === currentHGOId);
        } else {
          filteredUsers = [];
        }
      } else {
        // For Monazam portal: Exclude "Unclaimed" user from E-Hajj ledger
        // Include other users that have E-Hajj-related data
        filteredUsers = users.filter(user => {
          // Exclude "Unclaimed" user
          if (user.name === "Unclaimed") {
            return false;
          }
          // Include other users that have E-Hajj-related data
          return user.sarEhajjLedgerAmount !== null && user.sarEhajjLedgerAmount !== undefined;
        });
      }
      
      setUsers(filteredUsers);
      setError("");
      setLoading(false);
    })
    .catch((err) => {
      setError("Error fetching data");
      setLoading(false);
      ErrorToast(err?.response?.data?.message);
    });
};

export const CreateAccumulativeRequest = (
  requestData,
  setLoading,
  setError,
  handleCreate
) => {
  setLoading(true);
  Axios.post(
    "/ledger/accumulative-request",
    requestData,
    getConfig()
  )
    .then((res) => {
      setLoading(false);
      handleCreate();
    })
    .catch((err) => {
      setLoading(false);
      handleApiError(err, setError);
    });
};

export const PreviewEditMonazamTransaction = (
  transactionId,
  payload,
  setLoading,
  onSuccess,
  setError
) => {
  setLoading(true);
  Axios.post(
    `/ledger/monazam/transactions/${transactionId}/edit-preview`,
    payload,
    getConfig()
  )
    .then((res) => {
      setLoading(false);
      onSuccess(res.data?.data?.data || res.data?.data);
    })
    .catch((err) => {
      setLoading(false);
      handleApiError(err, setError);
    });
};

export const ApplyEditMonazamTransaction = (
  transactionId,
  payload,
  setLoading,
  onSuccess,
  setError
) => {
  setLoading(true);
  Axios.patch(
    `/ledger/monazam/transactions/${transactionId}`,
    payload,
    getConfig()
  )
    .then((res) => {
      setLoading(false);
      onSuccess(res.data?.data?.data || res.data?.data);
    })
    .catch((err) => {
      setLoading(false);
      handleApiError(err, setError);
    });
};
